import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSpeakerSharpFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 5.998V3.911l-1.627 1.308-5.058 4.066H3.001v6.288h3.372l5.085 3.27 1.541.992V5.998Zm5.823 1.775-.799-.602-1.204 1.597.799.602a3.41 3.41 0 0 1 1.379 2.631 3.413 3.413 0 0 1-1.38 2.632l-.798.602 1.204 1.596.799-.602a5.413 5.413 0 0 0 2.175-4.21v-.037c-.032-1.664-.847-3.208-2.175-4.21Zm-2.69 1.7-.814-.58-1.16 1.63.816.58c.088.063.166.138.229.22l.007.01c.378.483.29 1.187-.245 1.576l-.809.589 1.177 1.617.809-.589c1.419-1.033 1.74-3.018.647-4.42a3.071 3.071 0 0 0-.656-.633Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSpeakerSharpFill);
export default Memo;
